export default {
  'component.tagSelect.expand': '展开',
  'component.tagSelect.collapse': '收起',
  'component.tagSelect.all': '全部',
  'common.refresh': '刷新',
  'common.action': '操作',
  'common.settings': '设置',
  'common.cancel': '取消',
  'common.save': '保存',
  'common.confirm': '确认',
  'common.close': '关闭',
  'common.recommended': '推荐',
  'common.create': '创建',
  'common.update': '更新',
  'common.operationFailed': '操作失败',
  'common.reset': '重置',
};
